import type { ImageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Exact source PNG dimensions verified 2026-10-08. API metadata takes precedence.
// Asset URLs are intentional: a changed creative must not inherit a guessed ratio.
export const BANNER_IMAGE_CONFIG: {
  dimensions: Readonly<Record<string, ImageDimensions>>;
} = {
  dimensions: {
    'https://api.medistore.sk/files/fungalix-16-9-oegNzH6fNXZbWvbVtxFSlzEX9LNHw1xPAwD2zhvp.png?ai=0':
      {
        width: 1920,
        height: 1080,
      },
    'https://api.medistore.sk/files/skin-cap-16-9-yJvtIN13EQmPCVqrxhPoUGYN7yOLwysJzZxmY8B9.png?ai=0':
      {
        width: 1920,
        height: 1080,
      },
    'https://api.medistore.sk/files/skin-cap-380x380-SnfdnXkGXCqGTtRegF3j4ggIJ3y2fASI4JBYXJxS.png?ai=0':
      {
        width: 380,
        height: 380,
      },
    'https://api.medistore.sk/files/fungalix-380x380-2ca2tglrJbTQeOaH9wB8SUJ0HSYJvYbIwAxd1Bu5.png?ai=0':
      {
        width: 380,
        height: 380,
      },
    'https://api.medistore.sk/files/LlCb5NHPGd4TfILyNet1Js8ueUnkenZQwy6IQDk1.png?ai=0': {
      width: 1440,
      height: 351,
    },
    'https://api.medistore.sk/files/612DTwe4hIerrEAwSzWYciwGhhEFP75zwaRSAcQG.png?ai=0': {
      width: 393,
      height: 418,
    },
    'https://api.medistore.sk/files/JiTVk7QJydPurlz29rx0fx7rTryBm9Da29aEW8FD.png?ai=0': {
      width: 400,
      height: 120,
    },
    'https://api.medistore.sk/files/OdkM1wqrw6eO2KVwlVfxd9m5KcOBNKD91mjQoB6V.png?ai=0': {
      width: 400,
      height: 120,
    },
    'https://api.medistore.sk/files/W0KFgWz1YWDhcK2P81MOnhQdcHKbhbwycOUht3Tr.png?ai=0': {
      width: 400,
      height: 120,
    },
  },
};
